var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgASleep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.0005C19.0768 13.0005 21.2397 11.2285 21.8366 8.83653C21.4087 8.94336 20.961 9.00007 20.5 9.00007C17.4624 9.00007 15 6.53763 15 3.50007C15 3.0393 15.0567 2.59177 15.1634 2.16406C12.7717 2.76117 11 4.92394 11 7.50052C11 8.41324 11.2223 9.27403 11.6158 10.0317M5 7.00049V3.00049M3 5.00049H7M6 22.0005C3.79086 22.0005 2 20.2096 2 18.0005C2 16.0226 3.43551 14.3801 5.32148 14.0578C6.12876 11.6975 8.3662 10.0005 11 10.0005C13.2882 10.0005 15.2772 11.2814 16.2892 13.1653C16.6744 13.0579 17.0805 13.0005 17.5 13.0005C19.9853 13.0005 22 15.0152 22 17.5005C22 19.9858 19.9853 22.0005 17.5 22.0005C13.6667 22.0005 9.83333 22.0005 6 22.0005Z",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgASleep);
export default __webpack_public_path__ + "static/media/a-sleep.28f454afefacccf6711f0f34ceae455c.svg";
export { ForwardRef as ReactComponent };